import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'shop-order-banners',
  templateUrl: './shop-order-banners.html',
  standalone: false,
})
export class ShopBannersComponent {
  @Input('productsInCartArray') productsInCartArray: any;
  @Input('numberOfProductsInCart') numberOfProductsInCart: any;
  @Input('cartDiscount') cartDiscount: any;
  @Input('totalSp') totalSp: number;
  @Input('userDrImage') userDrImage: string;
  @Output() goToCart: EventEmitter<any> = new EventEmitter();
  @Output() viewportVisibilityChange: EventEmitter<boolean> = new EventEmitter();
  @Input() cartScriptBannerHeaderExperiment!: boolean;
  @Input() isShopRevampExperimentOn: boolean = false;

  handleClick():void {
    this.goToCart.emit();
  }

  handleViewportVisibilityChange(isIntersecting: boolean): void {
    this.viewportVisibilityChange.emit(isIntersecting);
  }
}
